import { Button, Card, CopyButton, Group, Stack, Text, Title } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';

import { unwrap } from '../api/client';
import { getReferral } from '../api/gen';
import { useOrg } from '../lib/session';
import { canShareNatively, intentUrl, inviteUrl, shareNatively } from '../lib/share';

// Familie einladen. One link per family: whoever starts through it tests for a
// month, and when that family books, this one gets a month free. The link
// names nobody — the page it opens says only that "a family" invites you.
export function InviteCard() {
  const org = useOrg();
  const { data } = useQuery({
    queryKey: ['referral'],
    queryFn: () => unwrap(getReferral({ headers: org })),
  });
  if (!data) return null;

  const url = inviteUrl(data.code);
  const text = 'Wir nutzen Sokrates für die Hausaufgaben – es gibt keine Lösungen, nur Fragen. Über diesen Link testet ihr einen Monat kostenlos:';

  return (
    <Card withBorder padding="lg">
      <Stack gap="sm">
        <Title order={5}>Familie einladen – einen Monat geschenkt</Title>
        <Text size="sm">
          Wer über euren Link startet, testet einen Monat statt 14 Tage. Bucht die Familie danach,
          bekommt ihr einen Monat geschenkt – als längere Testphase oder als Gutschrift auf die
          nächste Rechnung.
        </Text>
        <Card withBorder padding="xs" bg="gray.0">
          <Text size="sm" ff="monospace">
            {url}
          </Text>
        </Card>
        <Group>
          {canShareNatively ? (
            <Button color="junior" radius="xl" onClick={() => void shareNatively('Sokrates', text, url)}>
              Teilen …
            </Button>
          ) : null}
          <Button
            variant="light"
            color="green"
            onClick={() => window.open(intentUrl('whatsapp', text, url), '_blank', 'noopener')}
          >
            WhatsApp
          </Button>
          <CopyButton value={url}>
            {({ copied, copy }) => (
              <Button variant="default" onClick={copy}>
                {copied ? 'Link kopiert' : 'Link kopieren'}
              </Button>
            )}
          </CopyButton>
        </Group>
        <Text size="xs" c="dimmed">
          {data.invited} eingeladen · {data.converted} gebucht · {data.rewarded} Monat
          {data.rewarded === 1 ? '' : 'e'} geschenkt
        </Text>
      </Stack>
    </Card>
  );
}
